import {
  analyticsSlice,
  initAnalyticsServiceApi,
  initFileServiceApi,
  initMainApi,
  initSessionsApi,
  initTableCraftApi,
  organizationSlice,
} from '@carboncopyco/data';
import { tourCreatorSlice, tourEditorSlice } from '@carboncopyco/mimesis-sdk';
import { Debug } from '@carboncopyco/utils';
import { configureStore } from '@reduxjs/toolkit';
import { setupListeners } from '@reduxjs/toolkit/query/react';
import { combineReducers } from 'redux';
import { settings } from '../../../../settings';
import { LogRocket } from '../../shared/utils/tracking';
import { baseQuery } from './baseQuery';
import { baseQueryAnalytics } from './baseQueryAnalytics';

Debug.extend('demostack-data:store');

const mainApi = initMainApi(baseQuery());
const sessionApi = initSessionsApi(
  baseQuery({
    baseUrl: `${settings.ANALYTICS_DEMOSTACK_API}`,
  })
);
const fileServiceApi = initFileServiceApi(
  baseQuery({ baseUrl: `${settings.FILES_SERVICE_URL}` })
);
const analyticsServiceApi = initAnalyticsServiceApi(
  baseQueryAnalytics({
    baseUrl: `${settings.MENTAT_DOMAIN}`,
  })
);
const tableCraftApi = initTableCraftApi(
  baseQuery({
    baseUrl: `${settings.TABLE_CRAFT_DOMAIN}`,
  })
);

export const store = configureStore({
  reducer: combineReducers({
    [mainApi.reducerPath]: mainApi.reducer,
    [fileServiceApi.reducerPath]: fileServiceApi.reducer,
    [organizationSlice.name]: organizationSlice.reducer,
    [analyticsServiceApi.reducerPath]: analyticsServiceApi.reducer,
    [analyticsSlice.name]: analyticsSlice.reducer,
    [tourCreatorSlice.name]: tourCreatorSlice.reducer,
    [tourEditorSlice.name]: tourEditorSlice.reducer,
    [sessionApi.reducerPath]: sessionApi.reducer,
    [tableCraftApi.reducerPath]: tableCraftApi.reducer,
  }),
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoreState: true,
      },
    }).concat([
      mainApi.middleware,
      fileServiceApi.middleware,
      analyticsServiceApi.middleware,
      sessionApi.middleware,
      tableCraftApi.middleware,
      LogRocket.reduxMiddleware(),
    ]),
});

setupListeners(store.dispatch);
